class CollectionGridToggle {
  constructor() {
    this.storageKey = 'collection-mobile-grid-cols';
    this.productGrid = document.getElementById('product-grid');
    this.toggleRoot = document.querySelector('[data-collection-grid-toggle]');

    if (!this.productGrid || !this.toggleRoot) return;

    this.buttons = this.toggleRoot.querySelectorAll('[data-cols]');
    this.bindEvents();
    this.applyLayout(this.getSavedCols(), false);
  }

  getSavedCols() {
    const saved = localStorage.getItem(this.storageKey);
    return saved === '3' ? 3 : 2;
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const cols = parseInt(button.dataset.cols, 10);
        this.applyLayout(cols, true);
      });
    });

    const filterTrigger = document.querySelector('[data-mobile-filter-trigger]');
    const filterSummary = document.querySelector('.mobile-facets__disclosure summary');

    if (filterTrigger && filterSummary) {
      filterTrigger.addEventListener('click', () => {
        filterSummary.click();
      });
    }

    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const observer = new MutationObserver(() => {
        this.productGrid = document.getElementById('product-grid');
        if (this.productGrid) {
          this.applyLayout(this.getSavedCols(), false);
        }
      });
      observer.observe(gridContainer, { childList: true, subtree: true });
    }
  }

  applyLayout(cols, save = true) {
    if (!this.productGrid) {
      this.productGrid = document.getElementById('product-grid');
    }
    if (!this.productGrid) return;

    const isThreeCols = cols === 3;
    this.productGrid.classList.toggle('product-grid--mobile-cols-3', isThreeCols);
    this.productGrid.dataset.mobileCols = String(cols);

    this.buttons.forEach((button) => {
      const active = parseInt(button.dataset.cols, 10) === cols;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (save) {
      localStorage.setItem(this.storageKey, String(cols));
    }
  }
}

function initCollectionGridToggle() {
  if (!document.querySelector('[data-collection-grid-toggle]')) return;
  window.collectionGridToggle = new CollectionGridToggle();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionGridToggle);
} else {
  initCollectionGridToggle();
}
